import {
  CardSubSection,
  TechnologyCard,
  TechnologyCardList,
  TitleOption,
} from "@types"
import * as React from "react"
interface pricingCardsProps {
  innerCheckBoxes?: CardSubSection[]
  setTechnologyCards: Function
  technologyCard?: TechnologyCard
  cardIndex: number
  radioIndex?: number
  updateTechnologyCardTotalPrice: (cardIndex: number) => void
}
export const PricingCheckBox = ({
  cardIndex,
  innerCheckBoxes,
  setTechnologyCards,
  technologyCard,
  updateTechnologyCardTotalPrice,
  radioIndex,
}: pricingCardsProps) => {
  const [checkedItems, setCheckedItems] = React.useState(
    (innerCheckBoxes as CardSubSection[]).map((category) =>
      (category?.multiOptions ?? []).map((item: TitleOption) => ({
        ...item,
        isChecked: false,
        totalItems: 1,
      }))
    )
  )

  const toggleCheckbox = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]

    // Toggle the isChecked state for the specific item
    updatedCheckedItems[categoryIndex][listIndex].isChecked =
      !updatedCheckedItems[categoryIndex][listIndex].isChecked

    // Update the checkedItems state
    setCheckedItems(updatedCheckedItems)

    // Update the technologyCards state
    setTechnologyCards((prevTechnologyCards: TechnologyCard[]) =>
      prevTechnologyCards.map((card) =>
        card === technologyCard
          ? {
              ...card,
              technologyCards: card?.technologyCards?.map(
                (item: TechnologyCardList, index) =>
                  radioIndex === index
                    ? {
                        ...item,
                        cardSubSectionOptions: item?.cardSubSectionOptions?.map(
                          (section: CardSubSection, sectionIndex: number) => ({
                            ...section,
                            multiOptions: section?.multiOptions?.map(
                              (option: TitleOption, optionIndex: number) => {
                                const isChecked =
                                  sectionIndex === categoryIndex &&
                                  optionIndex === listIndex
                                    ? !option.isChecked
                                    : option.isChecked

                                // If the option is checked, update the totalPrice
                                if (isChecked) {
                                  // Calculate the price of the selected option
                                  const optionPrice = Number(option.price) || 0
                                  // Increase the total price by the price of the option
                                  item.totalPrice =
                                    (item.totalPrice || 0) + optionPrice
                                } else {
                                  // Decrease the total price by the price of the option
                                  const optionPrice = Number(option.price) || 0
                                  item.totalPrice =
                                    (item.totalPrice || 0) - optionPrice
                                }

                                return {
                                  ...option,
                                  isChecked,
                                }
                              }
                            ),
                          })
                        ),
                      }
                    : item
              ),
            }
          : card
      )
    )
    // Call updateTechnologyCardTotalPrice to update the card's total price
    updateTechnologyCardTotalPrice(cardIndex)
  }

  const increase = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]

    // Calculate the current item's total price before updating
    const currentItem = updatedCheckedItems[categoryIndex][listIndex]
    const currentTotalPriceWithItems =
      currentItem.totalItems * Number(currentItem.price)

    // Increase the totalItems
    updatedCheckedItems[categoryIndex][listIndex].totalItems += 1

    // Update the checkedItems state
    setCheckedItems(updatedCheckedItems)

    // Now calculate the new total price after increasing the quantity
    const newTotalPriceWithItems =
      updatedCheckedItems[categoryIndex][listIndex]?.totalItems *
      Number(updatedCheckedItems[categoryIndex][listIndex]?.price)

    // Update the technologyCards with the correct new total price
    setTechnologyCards((prevTechnologyCards: TechnologyCard[]) =>
      prevTechnologyCards.map((card) =>
        card.id === technologyCard?.id
          ? {
              ...card,
              // totalPrice:
              //   (card.totalPrice ?? 0) +
              //   (newTotalPriceWithItems - currentTotalPriceWithItems),
              technologyCards: card?.technologyCards?.map((item) => ({
                ...item,
                cardSubSectionOptions: item?.cardSubSectionOptions?.map(
                  (section: CardSubSection, sectionIndex: number) => ({
                    ...section,
                    multiOptions: section?.multiOptions?.map(
                      (option: TitleOption, optionIndex: number) => ({
                        ...option,
                        totalItems:
                          optionIndex === listIndex
                            ? (option.totalItems ?? 0) + 1
                            : (option.totalItems ?? 0),
                        totalPrice:
                          sectionIndex === categoryIndex &&
                          optionIndex === listIndex
                            ? newTotalPriceWithItems
                            : option.totalPrice,
                      })
                    ),
                  })
                ),
              })),
            }
          : card
      )
    )
    const targetCard = technologyCard
    if (targetCard) {
      // Update the total price for the specific technologyCard
      updateTechnologyCardTotalPrice(cardIndex)
    }
  }

  const decrease = (categoryIndex: number, listIndex: number) => {
    const updatedCheckedItems = [...checkedItems]

    // Calculate the current item's total price before updating
    const currentItem = updatedCheckedItems[categoryIndex][listIndex]
    const totalPriceWithItems =
      currentItem.totalItems * Number(currentItem.price)

    // Decrease the totalItems
    if (currentItem.totalItems > 1) {
      updatedCheckedItems[categoryIndex][listIndex].totalItems -= 1
    }

    // Update the checkedItems state
    setCheckedItems(updatedCheckedItems)

    // Now, calculate the new price after the decrease
    const newTotalPriceWithItems =
      updatedCheckedItems[categoryIndex][listIndex]?.totalItems *
      Number(updatedCheckedItems[categoryIndex][listIndex]?.price)

    // Update the technologyCards with the correct new total price
    setTechnologyCards((prevTechnologyCards: TechnologyCard[]) =>
      prevTechnologyCards.map((card) =>
        card.id === technologyCard?.id
          ? {
              ...card,
              // totalPrice:
              //   (card.totalPrice ?? 0) -
              //   (totalPriceWithItems - newTotalPriceWithItems),
              technologyCards: card?.technologyCards?.map((item) => ({
                ...item,
                cardSubSectionOptions: item?.cardSubSectionOptions?.map(
                  (section: CardSubSection, sectionIndex: number) => ({
                    ...section,
                    multiOptions: section?.multiOptions?.map(
                      (option: TitleOption, optionIndex: number) => ({
                        ...option,
                        totalItems:
                          optionIndex === listIndex
                            ? (option.totalItems ?? 0) - 1
                            : (option.totalItems ?? 0),
                        totalPrice:
                          sectionIndex === categoryIndex &&
                          optionIndex === listIndex
                            ? newTotalPriceWithItems
                            : option.totalPrice,
                      })
                    ),
                  })
                ),
              })),
            }
          : card
      )
    )
    const targetCard = technologyCard
    if (targetCard) {
      // Update the total price for the specific technologyCard
      updateTechnologyCardTotalPrice(cardIndex)
    }
  }
  const handleTotalItemsChange = (
    categoryIndex: number,
    listIndex: number,
    value: string
  ) => {
    const newTotalItems = Math.max(1, Number(value)) // Ensure minimum value is 1
    const updatedCheckedItems = [...checkedItems]

    // Update totalItems in checkedItems
    const currentItem = updatedCheckedItems[categoryIndex][listIndex]
    const previousTotalItems = currentItem.totalItems
    currentItem.totalItems = newTotalItems

    setCheckedItems(updatedCheckedItems)

    // Update totalPrice based on the new totalItems
    const newTotalPrice = newTotalItems * Number(currentItem.price)
    const previousTotalPrice = previousTotalItems * Number(currentItem.price)

    setTechnologyCards((prevTechnologyCards: TechnologyCard[]) =>
      prevTechnologyCards.map((card) =>
        card.id === technologyCard?.id
          ? {
              ...card,
              technologyCards:
                card?.technologyCards &&
                card?.technologyCards.map((item) => ({
                  ...item,
                  cardSubSectionOptions:
                    item?.cardSubSectionOptions &&
                    item?.cardSubSectionOptions.map(
                      (section: CardSubSection, sectionIndex: number) => ({
                        ...section,
                        multiOptions:
                          section?.multiOptions &&
                          section?.multiOptions.map(
                            (option: TitleOption, optionIndex: number) => ({
                              ...option,
                              totalItems:
                                sectionIndex === categoryIndex &&
                                optionIndex === listIndex
                                  ? newTotalItems
                                  : option.totalItems,
                              totalPrice:
                                sectionIndex === categoryIndex &&
                                optionIndex === listIndex
                                  ? newTotalPrice
                                  : option.totalPrice,
                            })
                          ),
                      })
                    ),
                })),
            }
          : card
      )
    )

    // Update the total price for the technologyCard

    updateTechnologyCardTotalPrice(cardIndex)
  }

  return (
    <div>
      {innerCheckBoxes?.map((subBox: CardSubSection, index: number) => (
        <div key={index}>
          <p className="text-black text-xs pt-2 font-bold ml-5">
            {subBox?.title}
          </p>
          {(subBox?.isRadioOptions === null ||
            subBox?.isRadioOptions === false) && (
            <>
              {subBox?.multiOptions?.map((options: TitleOption, i: number) => (
                <div key={i}>
                  {(subBox.isRadioOptions === null ||
                    subBox.isRadioOptions === false) && (
                    <div key={i} className="flex justify-between items-center">
                      <div className="px-3 pt-1 w-[80%] flex items-center justify-between">
                        <div className="flex my-1 gap-2 items-center ml-3">
                          {options?.price !== null && (
                            <div
                              onClick={() => toggleCheckbox(index, i)}
                              className="checkbox cursor-pointer relative border border-[#7B68EC] w-4 h-4 rounded"
                            >
                              {options?.isChecked && (
                                <div className="checked bg-[#7B68EC] text-xs absolute inset-0 w-full text-center text-white">
                                  ✓
                                </div>
                              )}
                            </div>
                          )}
                          <p className="text-xs font-normal text-gray">
                            {options?.option}
                          </p>
                        </div>
                        {subBox?.multiOptions !== null && (
                          <div className="flex items-center justify-center gap-1">
                            <div
                              onClick={() => decrease(index, i)}
                              className="flex cursor-pointer items-center justify-center w-4 h-4 rounded-full border border-[#7B68EC]"
                            >
                              <p className="text-black flex text-xs px-1">-</p>
                            </div>
                            <div
                              onClick={() => increase(index, i)}
                              className="flex cursor-pointer items-center justify-center w-4 h-4 rounded-full bg-[#7B68EC] border border-[#7B68EC]"
                            >
                              <p className="text-white flex text-xs px-1">+</p>
                            </div>
                            <input
                              type="number"
                              value={checkedItems[index][i]?.totalItems}
                              onChange={(e) =>
                                handleTotalItemsChange(index, i, e.target.value)
                              }
                              className="flex w-10 h-5 text-center border rounded bg-[#FFD85B] text-xs"
                              min="1"
                            />
                          </div>
                        )}
                      </div>
                      <div className="w-[20%] pt-2">
                        {options?.totalPrice !== undefined &&
                          options?.totalPrice > 0 && (
                            <p className="text-black font-bold text-center">
                              ${options?.totalPrice}
                            </p>
                          )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </>
          )}
          {subBox?.isRadioOptions === true && (
            <div className="flex w-[85%] flex-wrap">
              {subBox?.multiOptions?.map((options: TitleOption, i: number) => (
                <>
                  {subBox.isRadioOptions === true && (
                    <div key={i} className="w-1/2">
                      <div className="px-3 pt-2 flex items-center justify-between">
                        <div className="flex gap-2 items-center">
                          <div className="radio-border !border-[#7B68EC] rounded-full flex items-center justify-center p-1 w-5 h-5">
                            <input
                              className="input-radio !w-2 !h-2"
                              type="radio"
                              id={i.toString()}
                              value={i.toString()}
                              name={"cardsss" + radioIndex}
                              checked={checkedItems[index][i].isChecked}
                              onClick ={() => toggleCheckbox(index, i)}
                            />
                          </div>
                          <label
                            className="text-black text-nowrap text-[10px]"
                            htmlFor={i.toString()}
                          >
                            {options.option}
                          </label>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
